// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"791":"f98d713a","890":"fa9c05b8"}[chunkId] + ".css";
};